<template>
 <div @mouseover="videoMouseOver" @mouseleave="isShowControls=false" @fullscreenchange="isFullscreen = !isFullscreen" class="green-video-player" :class="{fullscreen: isFullscreen}" ref="greenVideoPlayer">
  <!--<div class="display"></div>-->
  <video @click="togglePlayAudio" class="video" :src="contentUrl" ref="video"></video>
  
  <!--再生・停止ボタン-->
  <div class="play-pause-btn" :class="{display_none: !isShowControls}" aria-label="Play" role="button">
    <div v-if="!loaded">
      <span class="play-pause-btn__icon"><i class="el-icon-loading"></i></span>
    </div>
    <div v-if="loaded">
      <span class="play-pause-btn__icon">
        <img src="@/assets/play.svg" v-if="play" @click="playAudio">
      </span>
    </div>
  </div>
  
  <!--再生時間のスライダー-->
  <div  class="seek" :class="{display_none: !isShowControls}">
    <el-slider v-model="currentTimePersentage" input-size="mini" class="seek__slider slider" :format-tooltip="formatTooltip" v-on:change="updateProgress(currentTimePersentage)"></el-slider>
  </div>
  
  <div class="controls" :class="{display_none: !isShowControls}">
    <div class="left_controls">
      <div class="holder">
        <div class="loading">
          <div class="loading__spinner"></div>
        </div>
    
        <!--再生・停止ボタン-->
        <div class="play-pause-btn" aria-label="Play" role="button">
          <div v-if="!loaded">
            <span class="play-pause-btn__icon"><i class="el-icon-loading"></i></span>
          </div>
          <div v-if="loaded">
            <span class="play-pause-btn__icon"><i class="el-icon-video-play" v-if="play" v-on:click="playAudio"></i></span>
            <span class="play-pause-btn__icon"><i class="el-icon-video-pause" v-if="pause" v-on:click="pauseAudio"></i></span>
          </div>
        </div>
        <div class="play_time">
          <span class="current-time" aria-live="off" role="timer">{{currentTime | formatMMSS}}</span>
          <span>/</span>
          <span class="total-time">{{duration | formatMMSS}}</span>
        </div>
      </div>
    </div>
    
    <div class="right_controls">
      
      <!--音声速度-->
      <div class="speed">
        <div v-on:click="changeSpeed">
         {{ videoSpeed.toFixed(1) }}x
        </div>
      </div>
    
      <!--音量のスライダー-->
      <div class="volume" v-if="!isSmartPhone">
        <el-popover placement="top-start" trigger="hover" width="50">
          <el-slider v-model="audioVolume" :step="10" input-size="mini" width :show-tooltip="false">
          </el-slider>
          <i class="el-icon-microphone" slot="reference" v-on:click="muteAudio" v-if="!mute"></i>
          <i class="el-icon-turn-off-microphone" slot=reference v-on:click="unmuteAudio" v-if="mute"></i>
        </el-popover>
      </div>
      
      <!--全画面表示-->
      <div class="screen" v-if="!isSmartPhone">
        <i v-if="!isFullscreen" class="el-icon-full-screen" v-on:click="toggleFullscreen"></i>
        <i v-if="isFullscreen" class="el-icon-close" v-on:click="toggleFullscreen"></i>
      </div>
    
      <div class="download">
        <a class="download__link" href="" download="" aria-label="Download" role="button">
          <svg width="24" height="24" fill="#566574" enable-background="new 0 0 29.978 29.978" version="1.1" viewBox="0 0 29.978 29.978" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
            <path d="m25.462 19.105v6.848h-20.947v-6.848h-4.026v8.861c0 1.111 0.9 2.012 2.016 2.012h24.967c1.115 0 2.016-0.9 2.016-2.012v-8.861h-4.026z"/>
            <path d="m14.62 18.426l-5.764-6.965s-0.877-0.828 0.074-0.828 3.248 0 3.248 0 0-0.557 0-1.416v-8.723s-0.129-0.494 0.615-0.494h4.572c0.536 0 0.524 0.416 0.524 0.416v8.742 1.266s1.842 0 2.998 0c1.154 0 0.285 0.867 0.285 0.867s-4.904 6.51-5.588 7.193c-0.492 0.495-0.964-0.058-0.964-0.058z"/>
          </svg>
        </a>
      </div>
    </div>
  
  </div>
</div>
</template>
<script>
  import { Analytics, AWSKinesisFirehoseProvider } from 'aws-amplify';
  // import { formatStoHHMMSS } from '@libs/PlayerUtils';
  import { formatStoMMSS, getApproxPersentage } from '@/libs/PlayerUtils';
  import Hls from 'hls.js';
  Analytics.addPluggable(new AWSKinesisFirehoseProvider());

  Analytics.configure({
    AWSKinesisFirehose: {
      region: 'ap-northeast-1',
      bufferSize: 1000,
      flushSize: 100,
      flushInterval: 5000,
      resendLimit: 5
    }
  });

  export default {
    name: 'GreenVideoPlayer',
    data() {
      return {
        videoElm: '',
        volume: {
          open: 'Open Volume Controls',
          close: 'Close Volume Controls',
        },
        loaded: false,
        pause: false,
        play: true,
        download: 'Download',
        src: '',
        currentTime: 0,
        currentTimePersentage: 0,
        duration: '',
        mute: false,
        videoSpeed: 1.0,
        videoSpeedList: [ 0.5, 1.0, 1.2, 1.5, 2.0 ],
        audioVolume: 100,
        userId: '',
        streamName: process.env.VUE_APP_KINESIS_DELIVERY_STREAM_NAME,
        intervalId: '',
        s3key: '',
        hls: new Hls(),
        isFullscreen: false,
        isShowControls: true,
        isSmartPhone: false,
        timer: null
      }
    },
    props: {
      contentUrl: String
    },
    computed: {},
    watch: {
      /**
       *currentTimeが更新される度に、％に直してスライダーに反映させる
       * 10％毎にFirehoseにイベントを送信する
       */
      currentTime: function() {
        this.currentTimePersentage = this.currentTime / this.duration * 100
        const approxPersentage = getApproxPersentage(this.currentTimePersentage)

        if (approxPersentage) {
          Analytics.record({
            data: {
              userId: this.userId,
              fileName: this.s3key,
              timestamp: new Date(),
              action: `${approxPersentage}%`,
            },
            streamName: this.streamName
          }, 'AWSKinesisFirehose');
        }

      },
      audioVolume: function() {
        this.videoElm.volume = this.audioVolume / 100;
        if (this.videoElm.volume === 0) {
          this.mute = true;
        }
        else {
          this.mute = false;
        }
      },

    },
    filters: {
      formatMMSS: function(time) {
        let mm = time / 60 | 0;
        let ss = time % 60 | 0;

        if (mm < 10) {
          mm = '0' + mm;
        }
        if (ss < 10) {
          ss = '0' + ss;
        }
        return `${mm}:${ss}`;
      }
    },
    beforeCreate: async function() {},
    created: function() {
      const ua = navigator.userAgent;
      if(ua.match(/iPhone|Android.+Mobile/)) {
        this.isSmartPhone = true;
      }
    },
    mounted: function() {
      this.videoElm = this.$refs.video;
      
      if(Hls.isSupported()) {
        this.hls.attachMedia(this.videoElm);
        this.hls.loadSource(this.contentUrl);
      }

      this.videoElm.addEventListener('loadedmetadata', function() {
        this.duration = this.videoElm.duration;
        this.loaded = true;
      }.bind(this));

      this.videoElm.addEventListener('ended', function() {
        this.videoElm.currentTime = 0;
        this.pause = !this.pause;
        this.play = !this.play;

        Analytics.record({
          data: {
            userId: this.userId,
            fileName: this.s3key,
            timestamp: new Date(),
            action: '100%',
          },
          streamName: this.streamName
        }, 'AWSKinesisFirehose');
      }.bind(this));

    },
    methods: {
      playAudio: async function() {
        this.intervalId = window.setInterval(function() {
          this.currentTime = this.videoElm.currentTime;
        }.bind(this), 1000);

        this.videoElm.play();
        this.pause = !this.pause;
        this.play = !this.play;

        /**
          後々ログイン機能を実装する可能性があるので残しておく
          処理内容
          現在ログインしている情報を付与して動画の再生情報をAWSに送信する機能
        **/
        // const currentUserInfo = await Auth.currentUserInfo();
        // console.log('現在ログイン中のユーザー');
        // console.log(currentUserInfo);
        // if(currentUserInfo) {
        //   this.email = currentUserInfo.attributes["email"];
        //   this.userId = currentUserInfo.id;
        // }

        // console.log("イベント送信前" + new Date())
        // console.log(formatStoHHMMSS(this.currentTime));

        // await Analytics.record({
        //   data: {
        //     userId: this.userId,
        //     fileName: this.s3key,
        //     timestamp: new Date(),
        //     action: 'play',
        //     currentTime: formatStoHHMMSS(this.currentTime)
        //   },
        //   streamName: this.streamName
        // }, 'AWSKinesisFirehose');
      },
      pauseAudio: async function() {
        this.videoElm.pause();
        this.pause = !this.pause;
        this.play = !this.play;
        window.clearInterval(this.intervalId);

        /**
          後々ログイン機能を実装する可能性があるので残しておく
          処理内容
          現在ログインしている情報を付与して動画の再生情報をAWSに送信する機能
        **/
        // await Analytics.record({
        //   data: {
        //     userId: this.userId,
        //     fileName: this.s3key,
        //     timestamp: new Date(),
        //     action: 'pause',
        //     currentTime: formatStoHHMMSS(this.currentTime)
        //   },
        //   streamName: this.streamName
        // }, 'AWSKinesisFirehose');

      },
      togglePlayAudio: function() {
        if(!this.isSmartPhone) {
          this.play ? this.playAudio() : this.pauseAudio();
        }
      },
      toggleFullscreen: function() {
        if(document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          const greenVideoPlayerElm = this.$refs.greenVideoPlayer;
          if(greenVideoPlayerElm.requestFullscreen()) {
            greenVideoPlayerElm.requestFullscreen();
          } else if(greenVideoPlayerElm.webkitRequestFullscreen()) {
            greenVideoPlayerElm.webkitRequestFullscreen();
          }
        }
      },
      videoMouseOver: function() {
        this.resetTimer()
        this.isShowControls = true;
        this.timer;
        // マウスを動かしたとき
        this.$refs.greenVideoPlayer.addEventListener('mousemove', () => {
          this.resetTimer()
          this.isShowControls = true;
        })
      },
      resetTimer: function() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.isShowControls = false;
        }, 3000);
      },
      updateProgress: function(updateProgressPersent) {
        const updatedCurrentTime = this.duration * updateProgressPersent / 100 | 0;
        this.videoElm.currentTime = updatedCurrentTime;
        this.currentTime = updatedCurrentTime;
      },
      formatTooltip: function() {
        return formatStoMMSS(this.currentTime);
      },
      formatMMSSMethod: function(time) {
        const mm = time / 60 | 0;
        const ss = time % 60 | 0;
        return `${mm}:${ss}`;
      },
      changeSpeed: function() {
        const currentVideoSpeedIndex = this.videoSpeedList.findIndex(speed => this.videoSpeed == speed);
        const nextVideoSpeedIndex = currentVideoSpeedIndex + 1;
        if(nextVideoSpeedIndex == this.videoSpeedList.length) {
          this.videoSpeed = this.videoSpeedList[0];
          this.videoElm.playbackRate = this.videoSpeed;
        } else {
          this.videoSpeed = this.videoSpeedList[nextVideoSpeedIndex];
          this.videoElm.playbackRate = this.videoSpeed;
        }
      },
      muteAudio: function() {
        this.videoElm.volume = 0;
        this.mute = true;
        this.audioVolume = this.videoElm.volume * 100
      },
      unmuteAudio: function() {
        this.videoElm.volume = 1;
        this.mute = false;
        this.audioVolume = this.videoElm.volume * 100
      }
    }

  }
</script>
<style>
  .green-video-player {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    padding: 32px;
    border-radius: 4px;
    user-select: none;
    box-sizing: border-box;
    outline: none;
  }
  
  .green-video-player .display {
    width: 100%;
    height: 380px;
    background: grey;
  }
  .green-video-player .video {
    width: 100%;
    height: 100%;
  }
  
  .green-video-player > .play-pause-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  .green-video-player > .play-pause-btn img {
    width: 120px;
  }
  
  .green-video-player .controls {
    position: relative;
    bottom: 0;
    /*width: 100%;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    padding: 0 12px;
    background-color: rgba(0,0,0,.3);
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.07);
  }
  
  .green-video-player .controls .right_controls {
    display:flex;
  }

  .green-video-player.player-accessible .play-pause-btn:hover,
  .green-video-player.player-accessible .seek:hover,
  .green-video-player.player-accessible .volume__button:hover,
  .green-video-player.player-accessible .volume__seek:hover,
  .green-video-player.player-accessible .download:hover {
    outline: dotted 1px #999;
  }

  .green-video-player svg,
  .green-video-player img {
    display: block;
  }

  .green-video-player .holder {
    display: flex;
    position: relative;
  }

  .green-video-player .holder .loading .loading__spinner {
    visibility: hidden;
    position: absolute;
    left: -3px;
    bottom: 2px;
    width: 16px;
    height: 16px;
    border: 2px solid #b0b0b0;
    border-right-color: rgba(0, 0, 0, 0);
    border-radius: 50%;
    animation: spin 0.4s linear infinite;
  }

  .green-video-player .holder .play-pause-btn {
    /*visibility: hidden;*/
    visibility: visible;
    cursor: pointer;
    outline: none;
  }
  
  .green-video-player .holder .play_time {
    display: flex;
    align-items: center;
    color: #fff;
    margin: 0 8px;
  }
  
  .green-video-player .holder .play_time span:nth-child(2) {
    margin: 0 4px;
  }
  
  .green-video-player .holder .play-pause-btn i,
  .green-video-player .volume i,
  .green-video-player .screen i {
    font-size: 28px;
    padding: 0 2px;
    cursor: pointer;
    color: #fff;
  }
  
  .green-video-player .holder .play-pause-btn i:hover,
  .green-video-player .volume i:hover,
  .green-video-player .screen i:hover {
    opacity: .8;
  }

  .green-video-player .holder .play-pause-btn:focus {
    outline: none;
  }

  .green-video-player .slider {
    flex-grow: 1;
    /*background-color: #d8d8d8;*/
    cursor: pointer;
    position: relative;
  }

  .green-video-player .slider .gap-progress {
    background-color: #44bfa3;
    border-radius: inherit;
    position: absolute;
    pointer-events: none;
  }

  .green-video-player .slider .gap-progress .pin {
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: #44bfa3;
    position: absolute;
    pointer-events: all;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.32);
  }

  .green-video-player .slider .gap-progress .pin::after {
    content: "";
    display: block;
    background: rgba(0, 0, 0, 0);
    width: 200%;
    height: 200%;
    margin-left: -50%;
    margin-top: -50%;
    border-radius: 50%;
  }

  .green-video-player .seek {
    position: relative;
    bottom: 100px;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    line-height: 18px;
    /*color: #55606e;*/
    color: #fff;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    /*margin-left: 15px;*/
    /*margin-right: 15px;*/
    margin-bottom: -100px;
    padding-top: 2px;
    outline: none;
  }

  .green-video-player .seek .seek__slider {
    margin-left: 16px;
    margin-right: 16px;
    /*border-radius: 2px;*/
    /*height: 0px;*/
  }

  .green-video-player .seek .seek__slider .seek__progress {
    width: 0;
    height: 100%;
  }

  .green-video-player .seek .seek__slider .seek__progress .progress__pin {
    right: -8px;
    top: -6px;
  }

  .green-video-player .seek span {
    cursor: default;
  }

  .green-video-player .seek:focus {
    outline: none;
  }
  
  .green-video-player .speed {
    display: flex;
    align-items: center;
    color: #fff;
    margin: 0 8px;
  }

  .green-video-player .speed:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .green-video-player .volume {
    position: relative;
  }

  .green-video-player .volume .volume__button {
    cursor: pointer;
    outline: none;
  }

  .green-video-player .volume .volume__button:focus {
    outline: none;
  }

  .green-video-player .volume .volume__button.open path {
    fill: #44bfa3;
  }

  .green-video-player .volume .volume__controls {
    width: 30px;
    height: 135px;
    background-color: rgba(0, 0, 0, 0.62);
    border-radius: 7px;
    position: absolute;
    left: -3px;
    bottom: 52px;
    flex-direction: column;
    align-items: center;
    display: flex;
    z-index: 2;
    outline: none;
  }

  .green-video-player .volume .volume__controls .volume__slider {
    margin-top: 12px;
    margin-bottom: 12px;
    width: 6px;
    border-radius: 3px;
  }

  .green-video-player .volume .volume__controls .volume__slider .volume__progress {
    bottom: 0;
    height: 100%;
    width: 6px;
  }

  .green-video-player .volume .volume__controls .volume__slider .volume__progress .volume__pin {
    left: -5px;
    top: -8px;
  }

  .green-video-player .volume .volume__controls:focus {
    outline: none;
  }

  .green-video-player .volume .volume__controls.hidden {
    display: none;
  }

  .green-video-player .volume .volume__controls.top {
    bottom: 52px;
    left: -3px;
  }

  .green-video-player .volume .volume__controls.middle {
    bottom: -54px;
    left: 54px;
  }

  .green-video-player .volume .volume__controls.bottom {
    bottom: -164px;
    left: -3px;
  }

  .green-video-player .download {
    display: none;
    margin-left: 16px;
    cursor: pointer;
    outline: none;
  }

  .green-video-player .download:focus {
    outline: none;
  }

  .green-video-player:focus {
    outline: none;
  }

  .message__offscreen {
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal;
  }
  
  .fullscreen .seek {
    bottom: 90px;
    margin-bottom: 0;
  }

  .fullscreen .controls {
    position: relative;
    /*height: 42px;*/
    bottom: 92px;
  }
  
  @media screen and (max-width: 768px) {
    .green-video-player > .play-pause-btn img {
      width: 70px;
    }
  }
  
  @media screen and (max-width: 530px) {
    .green-video-player > .play-pause-btn img {
      width: 48px;
    }
    .green-video-player .seek {
      bottom: 80px;
    }
    .green-video-player .holder .play-pause-btn i,
    .green-video-player .volume i, .green-video-player .screen i {
      font-size: 20px;
    }
    .green-video-player .controls {
      bottom: -18px;
      height: 38px;
    }
  }
  
  .display_none {
    opacity: 0;
    /*display: none !important;*/
    transition: .5s;
  }
</style>
